const TYPE_VALUES = {
  own: "own",
  all: "all",
};

export { TYPE_VALUES };
